module.exports = "../../../../platform/assets/pageMainIcon/industry_yewuchulilei6.svg";